
import { Component, PropSync, Prop, Watch, Vue, Ref } from "vue-property-decorator";
import VueQr from 'vue-qr';
import { getStoreTongueQrCode, getWszkTongueQrCode, getStorePhysiqueQrCode } from "@/api/store";

@Component({
  components: {
    VueQr
  }
})
export default class StoreTongueQrCode extends Vue {
  @PropSync("visible", { type: Boolean }) dialogVisible!: boolean;
  @Prop({ required: true }) storeId!: number;
  @Prop({ required: true }) storeName!: number;
  @Ref("qrCodeRef") qrCodeRef!: VueQr;
  @Ref("wsQrCodeRef") wsQrCodeRef!: VueQr;
  @Ref("physiqueQrCodeRef") physiqueQrCodeRef!: VueQr;

  qrCodeUrl = '';

  wszkQrCodeUrl = "";

  physiqueCodeUrl = "";

  secondImageUrl = "";

  threeImageUrl = "";

  get secondCodeUrl() {
    const info = { storeId: this.storeId, type: "wszk" };
    return  JSON.stringify(info);
  }

  @Watch('dialogVisible')
  onDialogVisibleChange(val: boolean) {
    if (val) {
      this.fetchQrCode();
      this.getWszkTongueQrCode();
      this.getStorePhysiqueQrCode();
    }
  }

  fetchQrCode() {
    getStoreTongueQrCode({ id: this.storeId }).then((res) => {
      this.qrCodeUrl = res.data;
    }).catch(() => {
      this.$message.error('获取二维码失败，请稍后再试');
      this.dialogVisible = false;
    });
  }

  getWszkTongueQrCode() {
    getWszkTongueQrCode({ id: this.storeId }).then((res) => {
      this.wszkQrCodeUrl = res.data;
    })
  }

  getStorePhysiqueQrCode() {
    getStorePhysiqueQrCode({ id: this.storeId }).then((res) => {
      this.physiqueCodeUrl = res.data;
    })
  }

  wszkQrCallback(url) {
    this.secondImageUrl = url;
  }

  physiqueQrCallback(url) {
    this.threeImageUrl = url;
  }

  downloadQrCode() {
    let a = document.createElement('a');
    a.download = this.storeName + '舌诊二维码';
    a.href = this.qrCodeRef.imgUrl;
    a.click();
  }

  downloadQrCode2() {
    let a = document.createElement('a');
    a.download = this.storeName + '望舌知康二维码';
    a.href = this.wsQrCodeRef.imgUrl;
    a.click();
  }

  downloadQrCode3() {
    let a = document.createElement('a');
    a.download = this.storeName + '体质辨识二维码';
    a.href = this.physiqueQrCodeRef.imgUrl;
    a.click();
  }
}
